var exports = {
  "az": "Box__gSM-Ui",
  "EY": "Text__R-8DjZ",
  "xR": "CommentBoxButton__EYDRAX",
  "wy": "Box_1__z8vF2q",
  "pv": "Box_2__7jrFqg",
  "UE": "Text_1__O53-tQ",
  "w9": "Box_3__dCtXaY",
  "pQ": "Box_4__syXrHX",
};

module.exports = exports;
